import { call, put, select } from 'redux-saga/effects';

import UserClient from '../../api/UserClient';

import { isAuthenticateSelector } from '../../selectors/login';

import { userSendLostPasswordSuccessful, userSendLostPasswordFailed } from '../../redux/user/actions';
import { messagesShow } from '../../redux/messages/actions';
// import getReCAPTCHAToken from "../getReCAPTCHAToken";

// export default function* ({ payload: { email, reCAPTCHAsiteKey } }) {
export default function*({ payload: { email } }) {
    try {
        // if (reCAPTCHAsiteKey) {
        //     const recaptchaData = yield call(getReCAPTCHAToken, 'sendLostPasswordEmail', reCAPTCHAsiteKey);
        //     yield call(UserClient.sendLostPasswordEmailWithRecaptcha, {
        //         email,
        //         ...recaptchaData,
        //     });
        // } else {
        yield call(UserClient.sendLostPasswordEmail, email);
        // }
        yield put(userSendLostPasswordSuccessful());

        const isAuthenticated = yield select(isAuthenticateSelector);
        yield put(messagesShow(isAuthenticated ? 'sendLostPasswordEmailAuth' : 'sendLostPasswordEmailOk', 'success'));
    } catch (error) {
        // The call goes through the anonymous client, so a 401 is not a lost
        // user session: it falls through to the generic error, no sign-out.
        if (error.code === 424) {
            yield put(userSendLostPasswordFailed());
            yield put(messagesShow('emailNotFound', 'error'));
        } else {
            yield put(userSendLostPasswordFailed());
            yield put(messagesShow('internalServerError', 'error'));
        }
    }
}
